// Who is on which side of a match, from each player's team_number. Singles
// has one player per team; doubles two. Match.getOtherPlayers() is everyone
// but me, which in doubles includes my teammate, so the match UI names its
// opponents from here instead.

function myId() {
	return typeof myUser === 'undefined' ? null : myUser?.id;
}

export function isDoublesMatch(match) {
	return Number(match?.team_size) === 2;
}

function entriesOf(match) {
	return Object.values(match?.players || {}).filter((entry) => entry && entry.player);
}

function hasTeamNumbers(match) {
	return entriesOf(match).some((entry) => entry.match?.team_number);
}

export function playersOnTeam(match, teamNumber) {
	return entriesOf(match)
		.filter((entry) => entry.match?.team_number === teamNumber)
		.map((entry) => entry.player);
}

export function playerOf(match, playerId) {
	if(playerId === null || playerId === undefined) {
		return null;
	}
	const entry = entriesOf(match).find((candidate) => String(candidate.player.id) === String(playerId));
	return entry ? entry.player : null;
}

function meOf(match) {
	return match?.players?.[myId()]?.player || (typeof myUser === 'undefined' ? null : myUser) || null;
}

// My team, me first.
export function myTeamOf(match) {
	if(!hasTeamNumbers(match)) {
		const me = meOf(match);
		return me ? [me] : [];
	}
	const team = playersOnTeam(match, match.getMyTeamNumber());
	return [...team].sort((first, second) => (String(second.id) === String(myId())) - (String(first.id) === String(myId())));
}

export function teammatesOf(match) {
	return myTeamOf(match).filter((player) => String(player.id) !== String(myId()));
}

export function opponentsOf(match) {
	if(!hasTeamNumbers(match)) {
		return match?.getOtherPlayers?.() || [];
	}
	return playersOnTeam(match, match.getOtherTeamNumber());
}

// "Moonwalk & Moss", or the fallback for an empty team.
export function teamNameOf(players, fallback = '') {
	const names = (players || []).map((player) => player.username).filter(Boolean);
	return names.length ? names.join(' & ') : fallback;
}

export function isTeammate(match, playerId) {
	return teammatesOf(match).some((player) => String(player.id) === String(playerId));
}
